export const SPECIAL_BTN_COLOR = '#ff4f00';
export const PAPERTRADING_COLOR = '#4f0101';

export const INDICATOR_GREEN_COLOR = '#00a86b';
export const INDICATOR_RED_COLOR = '#e52b50';
export const INDICATOR_RED_COLOR_TEXT = '#ee3a5e';
export const INDICATOR_YELLOW_COLOR = '#ffea00';
export const INDICATOR_INFO_COLOR = '#00bfff';
export const INDICATOR_VLT_COLOR = '#ff9800';
export const INDICATOR_NA_COLOR = '#ccc';
export const INDICATOR_LOSS_COLOR = '#cf7360';

export const INDICATOR_TRAILING_COLOR = '#0981f1';
export const INDICATOR_PREP_COLOR = '#ffea00'; // '#0981f1';
export const INDICATOR_PREPOST_MARKET_COLOR = '#ffea00';

export const WHITE_COLOR = '#fff';
export const WHITE_TEXT_COLOR = '#e1e1e1';
export const GRAY_COLOR = '#808080';
export const BLACK_COLOR = '#212121';
export const GOLD_COLOR = '#ffd700';
export const SIGNAL_GREEN_COLOR = '#1ff462';
export const SIGNAL_PINK_COLOR = '#f02bdc';
export const STRIKE_COLOR = '#ffd700';
export const AVG_COLOR = '#ace1af';
export const AVERAGING_COLOR = '#de6f42';

export const TRADE_BUY_COLOR = '#00cc99';
export const TRADE_SELL_COLOR = '#ff2052';

export const TABLE_BORDER_COLOR = '#515151';

export const CORRECTION_COLOR_1 = '#5729c2';
export const CORRECTION_COLOR_2 = '#cb46c9';
export const CORRECTION_COLOR_3 = '#3b7658';
export const CORRECTION_COLOR_4 = '#8af4a4';

export const SLOW_PNL_COLOR = '#e2c311';
export const FAST_PNL_COLOR = '#2c9fa5';
